<div class="dashboard" [class.is-edit-mode]="isEditMode">
  <!-- Success Alert -->
  <div *ngIf="showSuccessAlert" class="alert-container">
    <div class="jquery-style-toast" [ngClass]="toastType">
      <div class="toast-text">
        {{ toastMessage }}
      </div>
      <button class="close-toast" (click)="showSuccessAlert = false">&times;</button>
    </div>
  </div>

  <header class="dashboard-header" [class.edit-mode]="isEditMode">
    <ng-container *ngIf="!isEditMode">
      <div class="left-section">
        <h1 class="dashboard-title">Dashboard</h1>
        <button class="customize-btn" (click)="toggleEditMode()">
          <img src="assets/icons/img-edit-rectangle.svg" class="icon" alt="Customize" />
          <span>Customize Widgets</span>
        </button>
      </div>

      <div class="right-section">
        <button class="widgets-btn" (click)="toggleWidgetsDrawer()">
          <img src="assets/icons/img-apps-add.svg" class="icon" alt="Add Widgets" />
          <span>Widgets</span>
        </button>
        <img src="assets/icons/img-notification.svg" class="bell-icon" alt="Notifications"
          (click)="toggleNotifications()" />
      </div>
    </ng-container>

    <ng-container *ngIf="isEditMode">
      <div class="edit-header-container">
        <button class="edit-action-btn close" (click)="toggleEditMode()">Close</button>
        <span class="edit-header-title">Customize <span class="title-widgets-text">Widgets</span></span>

        <div class="edit-right-actions">
          <button class="edit-action-btn save" (click)="saveLayout()">Save</button>
          <button class="widgets-btn" (click)="toggleWidgetsDrawer()">
            <img src="assets/icons/img-apps-add.svg" class="icon" alt="Add Widgets" />
            <span>Widgets</span>
          </button>
          <img src="assets/icons/img-notification.svg" class="bell-icon" alt="Notifications"
            (click)="toggleNotifications()" />
          <!-- <button class="edit-action-btn save" (click)="saveLayout()">Save</button> -->
        </div>
      </div>
    </ng-container>
  </header>

  <!-- Edit Mode Banner -->
  <div class="edit-mode-banner" *ngIf="isEditMode">
    <span class="banner-text">Add, resize, or remove widgets anytime.</span>
    <button class="help-btn" (click)="startIntro()">
      <div class="help-icon-circle">?</div>
      <span>How does this work?</span>
    </button>
  </div>

  <main class="widget-container" cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="drop($event)"
    [cdkDropListDisabled]="!isEditMode">
    <div class="empty-state-message" *ngIf="widgets.length === 0">
      <div class="message-title">Your Dashboard is Empty</div>
      <div class="message-subtitle">Add widgets to customize your experience</div>
    </div>
    <div *ngFor="let widget of widgets; let i = index" class="widget-wrapper" [ngClass]="widget.size"
      [style.gridColumn]="widget.colSpan ? 'span ' + widget.colSpan : null" cdkDrag [cdkDragDisabled]="!isEditMode"
      (click)="selectWidget(i)" [class.selected]="selectedWidgetIndex === i">
      <article class="widget" [style.height.px]="widget.customHeight">
        <section class="content" cdkDragHandle>
          <ng-container *ngComponentOutlet="
    componentMapper[widget.type];
    inputs: {
      title: widget.title,
      size: widget.size,
      index: i,
      isEditMode: isEditMode,
      activeDropdownIndex: activeDropdownIndex,
      getAvailableSizes: getAvailableSizes,
      toggleSizeDropdown: toggleSizeDropdown,
      changeWidgetSize: changeWidgetSize,
      removeWidget: removeWidget
    }
  ">
          </ng-container>

        </section>
        <div class="resize-handle" *ngIf="isEditMode" (mousedown)="startResize($event, widget)"></div>
      </article>
    </div>
  </main>

  <!-- Sticky Add Widgets Button (Only in Edit Mode) -->
  <div class="sticky-add-widgets-container" *ngIf="isEditMode">
    <button class="add-widgets-btn" (click)="toggleAddWidgetsModal()">
      <span>Add Widgets</span>
    </button>
  </div>

  <!-- Widgets Right Drawer -->
  <app-widgets-right-drawer *ngIf="isWidgetsDrawerOpen" [activeWidgets]="widgets" (close)="toggleWidgetsDrawer()"
    (toggleEdit)="toggleEditMode()" (addWidgetRequest)="handleAddWidget($event)">
  </app-widgets-right-drawer>

  <!-- Add Widgets Modal -->
  <app-add-widgets-modal *ngIf="isAddWidgetsModalOpen" [activeWidgets]="widgets" (close)="toggleAddWidgetsModal()"
    (addWidgetRequest)="handleAddWidget($event)">
  </app-add-widgets-modal>

  <!-- Guide Modal -->
  <app-guide-modal *ngIf="isGuideVisible" [isVisible]="isGuideVisible" (close)="closeGuide()"></app-guide-modal>
</div>